import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ClusterRejectionRequest } from '../../types/cluster'
import api from '../../api'

const useRejectCluster = (clusterID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (clusterRejection: ClusterRejectionRequest) => {
			return api.clusters.rejectCluster(clusterRejection)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['clusters'] })
			queryClient.invalidateQueries({ queryKey: ['cluster', clusterID] })
		}
	})
}

export default useRejectCluster
